import { MessageCircle } from "lucide-react";
import { BRAND } from "@/data/site";

export default function FloatingWhatsApp() {
  const href = `https://wa.me/${BRAND.whatsapp}?text=${encodeURIComponent("Hi GrabNChat, I'd like to learn more!")}`;
  return (
    <a
      href={href}
      target="_blank"
      rel="noopener noreferrer"
      className="fixed bottom-6 right-6 z-40 bg-[#25D366] hover:bg-[#1DA851] text-white rounded-full p-4 shadow-xl glow-green transition-transform hover:scale-105"
      aria-label="Chat on WhatsApp"
      data-testid="floating-whatsapp-btn"
    >
      <MessageCircle className="w-6 h-6" />
    </a>
  );
}
